import React from 'react';
import UserCompanyDetailsForm from '../settings/UserCompanyDetailsForm';
import * as StyledPaymentPopup from './PaymentPopup.styles';
import * as Styled from './PaymentPopupCompanyDetails.styles';
import { Trans, useTranslation } from 'react-i18next';

interface PaymentPopupCompanyDetailsProps {
  onComplete: () => void;
  onBack: () => void;
}

const PaymentPopupCompanyDetails: React.FC<PaymentPopupCompanyDetailsProps> = ({ onComplete, onBack }) => {
  const { t } = useTranslation();
  return (
    <div>
      <StyledPaymentPopup.Headline>
        <Trans i18nKey='shared.paymentPopupCompanyDetails.title' components={{ span: <span /> }} />
      </StyledPaymentPopup.Headline>

      <UserCompanyDetailsForm
        displayTerms
        buttonText={t('common.next')}
        onComplete={onComplete}
        additionalButton={
          <Styled.ButtonBack variant='outlined' onClick={() => onBack()}>
            {t('common.back')}
          </Styled.ButtonBack>
        }
      />
    </div>
  );
};

export default PaymentPopupCompanyDetails;
